import { setCachedPremiumPicks } from "../../../../helpers/cache-premium-picks";

// Action Types
const name = "PREMIUM_PICKS_CATALOG";
const LOAD_PREMIUM_PICKS_LIST = `${name}/LOAD_PREMIUM_PICKS_LIST`;
const IS_LOADING_PREMIUM_PICKS = `${name}/IS_LOADING_PREMIUM_PICKS`;

// Reducer
const initialState = {
  currentPicks: {},
  upcomingPicks: {},
  isLoading: true,
  loadError: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_PREMIUM_PICKS_LIST:
      return {
        ...state,
        currentPicks: action.currentPicks,
        upcomingPicks: action.upcomingPicks,
        isLoading: false,
        loadError: null
      };
    case IS_LOADING_PREMIUM_PICKS:
      return {
        ...state,
        isLoading: true
      };
    default:
      return state;
  }
}

// Actions
export const fetchPremiumPicks = (hideMature = false) => {
  return async function(dispatch) {
    dispatch({ type: IS_LOADING_PREMIUM_PICKS });

    let promises = [$.get(`/v4/2023-rotating-catalog`)];

    if (hideMature) {
      const username = wattpad.utils.currentUser().get("username");
      promises.push($.get(`/v5/users/${username}/content-settings`));
    }

    Promise.all(promises)
      .then(async ([premiumPicks, contentSettings]) => {
        setCachedPremiumPicks(premiumPicks);

        let currentPicks = premiumPicks.current;
        let upcomingPicks = premiumPicks.next;

        if (hideMature && !contentSettings?.includeMature) {
          currentPicks.stories = currentPicks.stories.filter(
            story => !story.mature
          );
          upcomingPicks.stories = upcomingPicks.stories.filter(
            story => !story.mature
          );
        }

        dispatch({
          type: LOAD_PREMIUM_PICKS_LIST,
          currentPicks,
          upcomingPicks
        });
      })
      .catch(err => {
        dispatch({ type: LOAD_PREMIUM_PICKS_LIST, loadError: err });
      });
  };
};
